import { TRANSACTIONS, FETCH_MORE_TRANSACTIONS, GET_TRANSACTION, SEARCHED_TRANSACTIONS } from '../types/index';

const initialState = {

    data: [],

    pages: null,

    page: 1,

    next_page: null,

    transaction: {}

};

export default function(state = initialState, action) {

    switch(action.type) {

        case TRANSACTIONS: 

            return {

                ...state,

                data: action.payload.data,

                pages: action.payload.pages,

                page: action.payload.page,

                next_page: action.payload.next_page

            };

        case FETCH_MORE_TRANSACTIONS: 

            return {

                ...state,

                data: state.data.concat(action.payload.data),

                pages: action.payload.pages,

                page: action.payload.page,

                next_page: action.payload.next_page

            };

        case GET_TRANSACTION:

            return {

                ...state,

                transaction: action.payload

            }

        case SEARCHED_TRANSACTIONS: 

            return {

                ...state,

                data: action.payload,

                pages: null,

                page: 1,

                next_page: null

            };

        default:

            return state;

    }

};